import type { ResumenPeriodoPyg } from './tipos'
import estilos from './PygProyectos.module.css'

function formatoPesos(valor: number): string {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0,
  }).format(Math.round(valor))
}

type Props = {
  resumen: ResumenPeriodoPyg | null
  etiquetaPeriodo: string
}

export function TarjetasKpiPyg({ resumen, etiquetaPeriodo }: Props) {
  if (!resumen) return null

  const cumplePlan = resumen.cumplimientoPct >= 100
  const superaUtilidad = resumen.desviacionUtilidad >= 0

  return (
    <div className={estilos.tarjetasKpisGrid}>
      {/* 1. Debía producirse */}
      <div className={`${estilos.kpiCard} ${estilos.kpiCardPlan}`}>
        <span className={estilos.kpiTitulo}>Debía producirse</span>
        <b className={estilos.kpiValor}>{formatoPesos(resumen.planeado)}</b>
        <span className={estilos.kpiSubtexto}>
          según cronograma en {etiquetaPeriodo}
        </span>
      </div>

      {/* 2. Se produjo */}
      <div className={`${estilos.kpiCard} ${estilos.kpiCardProd}`}>
        <span className={estilos.kpiTitulo}>Se produjo</span>
        <b className={estilos.kpiValor}>{formatoPesos(resumen.produccion)}</b>
        <span className={estilos.kpiSubtexto}>
          {resumen.planeado === 0 ? (
            'sin meta fijada para este lapso'
          ) : (
            <span className={cumplePlan ? estilos.badgeOk : estilos.badgeAlerta}>
              {resumen.cumplimientoPct}% de lo previsto
            </span>
          )}
        </span>
      </div>

      {/* 3. Utilidad esperada */}
      <div className={estilos.kpiCard}>
        <span className={estilos.kpiTitulo}>Utilidad esperada</span>
        <b className={estilos.kpiValor}>{formatoPesos(resumen.utilidadPlaneada)}</b>
        <span className={estilos.kpiSubtexto}>
          margen proyectado si se cumplía el plan
        </span>
      </div>

      {/* 4. Utilidad real */}
      <div className={`${estilos.kpiCard} ${superaUtilidad ? estilos.kpiCardUtilidad : estilos.kpiCardUtilidadAlerta}`}>
        <span className={estilos.kpiTitulo}>Utilidad real ({etiquetaPeriodo})</span>
        <b className={estilos.kpiValor}>{formatoPesos(resumen.utilidadReal)}</b>
        <span className={estilos.kpiSubtexto}>
          {Math.abs(resumen.desviacionUtilidad) < 1000 ? (
            'exacto a lo esperado'
          ) : (
            <>
              <b>{formatoPesos(Math.abs(resumen.desviacionUtilidad))}</b>
              {superaUtilidad ? ' por encima de la meta' : ' por debajo de la meta'}
            </>
          )}
        </span>
      </div>
    </div>
  )
}
